function updateMenuItems(selector) {
    document.querySelectorAll(selector).forEach(elem => {
        let textContent = elem.textContent.trim();
        let title = textContent, imgSrc, color;

        if (textContent.includes('##')) {
            [title, color] = textContent.split('##').map(part => part.trim());
        }

        if (title.includes('|')) {
            [title, imgSrc] = title.split('|').map(part => part.trim());

            const imgElement = document.createElement('img');
            imgElement.src = imgSrc;
            imgElement.alt = '';
            imgElement.style.maxWidth = '100%';
            imgElement.style.height = 'auto';

            const titleSpan = document.createElement('span');
            titleSpan.classList.add('button', 'button--white', 'button--nohover', 'button--s');
            titleSpan.textContent = title;
            if (color) titleSpan.style.color = color;

            const container = document.createElement('div');
            container.classList.add('lpb-menu-image');
            container.appendChild(imgElement);
            container.appendChild(titleSpan);

            elem.innerHTML = '';
            elem.appendChild(container);
            const parentLi = elem.closest('li');
            if (parentLi) parentLi.classList.add('lpb-menu-custom-li');
        } else if (title.includes('&&')) {
            [title] = title.split('&&').map(part => part.trim());
            const spanElement = elem.querySelector('span');
            if (spanElement) {
                spanElement.classList.add('lpb-menu-title', 'lpb-body-m-bold');
                spanElement.textContent = title;
                if (color) spanElement.style.color = color;
            }
        } else if (color) {
            const spanElement = elem.querySelector('span');
            if (spanElement) {
                spanElement.textContent = title; 
                spanElement.style.color = color;
            }
        }
    });
}

updateMenuItems('.mega-menu__link'); 
updateMenuItems('.menu-drawer__menu-item'); 
updateMenuItems('.list-menu.list-menu--inline > li > a');
updateMenuItems('.menu-drawer__menu > li > a'); 